module.exports = __webpack_public_path__ + "img/caret-right.736f0464.svg";